import { useEffect } from 'react';

interface UseVideoKeyboardControlsProps {
	isOpen: boolean;
	showRecordButton: boolean;
	isRecording: boolean;
	restartRecording: () => void;
	startRecording: () => void;
	stopRecording: () => void;
}

export const useVideoKeyboardControls = ({
	isOpen,
	showRecordButton,
	isRecording,
	startRecording,
	stopRecording,
	restartRecording,
}: UseVideoKeyboardControlsProps) => {
	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			if (event.code === 'Space') {
				event.preventDefault();
				event.stopPropagation();
				if (isOpen && showRecordButton) {
					startRecording();
				} else if (isRecording) {
					stopRecording();
				}
			}

			if (event.code === 'KeyR') {
				restartRecording();
			}
		};

		if (isOpen) {
			window.addEventListener('keydown', handleKeyDown);
		} else {
			window.removeEventListener('keydown', handleKeyDown);
		}
		return () => window.removeEventListener('keydown', handleKeyDown);
	}, [isOpen, showRecordButton, isRecording, startRecording, stopRecording]);
};
